export default __webpack_public_path__ + "static/media/banner.21ac0490.png";